import { createQueryKeys } from '@lukemorales/query-key-factory';

export const files = createQueryKeys('files', {
  choices: null,
  retrieve: (fileId: string) => [fileId],
  update: (fileId: string) => [fileId],
  delete: (fileId: string) => [fileId],
});
